const { createAction } = require("../../helpers");
const {
  GET_CARTS,
  GET_CARTS_SUCCESS,
  GET_CARTS_ERROR,
  GET_CARTS_RESET,

  GET_CARTS_COUNT,
  GET_CARTS_COUNT_SUCCESS,
  GET_CARTS_COUNT_ERROR,
  GET_CARTS_COUNT_RESET,

  CREATE_CART,
  CREATE_CART_SUCCESS,
  CREATE_CART_ERROR,
  CREATE_CART_RESET,

  CREATE_SERVICES_CART,
  CREATE_SERVICES_CART_SUCCESS,
  CREATE_SERVICES_CART_ERROR,
  CREATE_SERVICES_CART_RESET,

  DELETE_CART,
  DELETE_CART_SUCCESS,
  DELETE_CART_ERROR,
  DELETE_CART_RESET,

  REORDER,
  REORDER_SUCCESS,
  REORDER_ERROR,
  REORDER_RESET,

  GET_SERVICES_CARTS,
  GET_SERVICES_CARTS_SUCCESS,
  GET_SERVICES_CARTS_ERROR,
  GET_SERVICES_CARTS_RESET,
} = require("./constants");

const cart = ({ page, pageSize, isBusiness }) =>
  createAction(GET_CARTS, { page, pageSize, isBusiness });

const cartSuccess = (data) => createAction(GET_CARTS_SUCCESS, { data });

const cartError = (error) => createAction(GET_CARTS_ERROR, { error });

const cartReset = () => createAction(GET_CARTS_RESET);

const servicesCart = ({ page, pageSize, isBusiness, mode }) =>
  createAction(GET_SERVICES_CARTS, { page, pageSize, isBusiness, mode });

const servicesCartSuccess = (data) =>
  createAction(GET_SERVICES_CARTS_SUCCESS, { data });

const servicesCartError = (error) =>
  createAction(GET_SERVICES_CARTS_ERROR, { error });

const servicesCartReset = () => createAction(GET_SERVICES_CARTS_RESET);

const cartsCount = () => createAction(GET_CARTS_COUNT);

const cartsCountSuccess = (data) =>
  createAction(GET_CARTS_COUNT_SUCCESS, { data });

const cartsCountError = (error) =>
  createAction(GET_CARTS_COUNT_ERROR, { error });

const cartsCountReset = () => createAction(GET_CARTS_COUNT_RESET);

const createServicesCart = ({
  packageId,
  quantity,
  isBusiness,
  mode,
  operation,
  couponId,
}) =>
  createAction(CREATE_SERVICES_CART, {
    packageId,
    quantity,
    isBusiness,
    operation,
    mode,
    couponId,
  });

const createServicesCartSuccess = (data) =>
  createAction(CREATE_SERVICES_CART_SUCCESS, { data });

const createServicesCartError = (error) =>
  createAction(CREATE_SERVICES_CART_ERROR, { error });

const createServicesCartReset = () => createAction(CREATE_SERVICES_CART_RESET);

const createCart = ({
  inventoryId,
  quantity,
  isBusiness,
  operation,
  couponId,
}) =>
  createAction(CREATE_CART, {
    inventoryId,
    quantity,
    isBusiness,
    operation,
    couponId,
  });

const createCartSuccess = (data) => createAction(CREATE_CART_SUCCESS, { data });

const createCartError = (error) => createAction(CREATE_CART_ERROR, { error });

const createCartReset = () => createAction(CREATE_CART_RESET);

const deleteCart = (id) => createAction(DELETE_CART, { id });

const deleteCartSuccess = (data) => createAction(DELETE_CART_SUCCESS, { data });

const deleteCartError = (error) => createAction(DELETE_CART_ERROR, { error });

const deleteCartReset = () => createAction(DELETE_CART_RESET);

const reOrder = ({ inventoryId, quantity, isBusiness, operation, couponId }) =>
  createAction(REORDER, {
    inventoryId,
    quantity,
    isBusiness,
    operation,
    couponId,
  });

const reOrderSuccess = (data) => createAction(REORDER_SUCCESS, { data });

const reOrderError = (error) => createAction(REORDER_ERROR, { error });

const reOrderReset = () => createAction(REORDER_RESET);

module.exports = {
  cart,
  cartSuccess,
  cartError,
  cartReset,

  cartsCount,
  cartsCountSuccess,
  cartsCountError,
  cartsCountReset,

  createCart,
  createCartSuccess,
  createCartError,
  createCartReset,

  createServicesCart,
  createServicesCartSuccess,

  createServicesCartError,
  createServicesCartReset,

  deleteCart,
  deleteCartSuccess,
  deleteCartError,
  deleteCartReset,

  reOrder,
  reOrderSuccess,
  reOrderError,
  reOrderReset,

  servicesCart,
  servicesCartSuccess,
  servicesCartError,
  servicesCartReset,
};
